// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import platformSingleton from '../../../../platform/platformSingleton';
import { isPlatformElectronMac } from '../../../../platform/utils/platformDetailsUtils';

// Selectors
import { isUploadingAttachment } from '../../../../element/attachments/attachmentsSelector';

// Actions
import { electronClearCloseMessage, electronSetCloseMessage } from '../../../../../common/electron/electronActions';

const mapDispatchToProps = (dispatch) => ({
    dispatchSetCloseMessage: () =>
        dispatch(
            electronSetCloseMessage({
                message: 'In-progress uploads will be lost if you quit',
                title: 'In-progress uploads',
            }),
        ),
    dispatchClearCloseMessage: () => dispatch(electronClearCloseMessage()),
});

let FileUploadWindowCloseBlocker = (props) => {
    React.useEffect(() => {
        const { dispatchSetCloseMessage, dispatchClearCloseMessage } = props;

        const onBeforeUnload = (event) => {
            const returnValue = 'In-progress uploads will be lost if you close this tab';
            event.returnValue = returnValue;
            return returnValue;
        };

        const isElectron = isPlatformElectronMac(platformSingleton);
        window.addEventListener('beforeunload', onBeforeUnload);
        if (isElectron && dispatchSetCloseMessage) dispatchSetCloseMessage();

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            if (isElectron && dispatchClearCloseMessage) dispatchClearCloseMessage();
        };
    }, []);

    return null;
};

FileUploadWindowCloseBlocker.propTypes = {
    dispatchSetCloseMessage: PropTypes.func,
    dispatchClearCloseMessage: PropTypes.func,
};

FileUploadWindowCloseBlocker = connect(null, mapDispatchToProps)(FileUploadWindowCloseBlocker);

const mapStateToProps = createStructuredSelector({
    isUploading: isUploadingAttachment,
});

const FileUploadWindowCloseBlockerConditional = ({ isUploading }) =>
    isUploading ? <FileUploadWindowCloseBlocker /> : null;

FileUploadWindowCloseBlockerConditional.propTypes = {
    isUploading: PropTypes.bool,
};

export default connect(mapStateToProps)(FileUploadWindowCloseBlockerConditional);
